import * as React from 'react';
import {useTranslation} from "react-i18next";
import {Button} from "@mui/material";

interface ISaveButtonProps {
    loading: boolean;
    onSubmit(e: any): void;
    label?: string;
    fullWidth?: boolean;
    disabled?: boolean;
}

export const SaveButton = ({loading, onSubmit, label, fullWidth = false, disabled}: ISaveButtonProps) => {
    const { t } = useTranslation();

    return (
        <Button
            type="submit"
            onClick={onSubmit}
            disabled={disabled === undefined ? loading : disabled}
            variant="contained"
            color="primary"
            fullWidth={fullWidth}
        >
            {label || t('global.buttons.save')}
        </Button>
    );
}
